export default {

	// api请求地址
	baseUrl: 'https://erp.fulibbc.com/',

	// 图片域名
	imgDomain: 'https://erp.fulibbc.com/',

	// 腾讯地图key
	 mpKey: 'X3IBZ-IGOC7-MACXX-PHOCR-RCCTH-LYBGL',

	// 客服
	 webSocket: 'wss://erp.fulibbc.com/wss',

	// api安全
	apiSecurity: false,

	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500,

	// 公钥
	publicKey: `-----BEGIN PRIVATE KEY-----
MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQChRPJx5DmUJkXt
0O7Z7BK7B5aPG18naWVx1MGR9sLKLm4eWY69bTaUq1MCA5qE7b2Ywlkvev/o/+ig
QrmrQktdYLma7dgDtwxr+sKQX9nnlIh/jjIpSYSIwFmdciUBrnoNJaMQRD77FuKg
4/000ypghuSMKyhii9jttoTGUsHC5Lzo/XTL1nMzSxYAcUu38EV4gA9oY6hqfx2e
eFnhWSkA+yjrcxe6544XdHsJZOShGCWO2G5VacETMfAAter6INXwdYeQiEq94kO7
u+xORsFG4GjzH+Jn9VnBp5vcOfKbJAirAS484GFiwa1jBUgw1ID7kxKOI+3lR+4d
cOPvqVo9AgMBAAECggEALIRm1K+mgVHrXdGeDYQQS5a1pf1tT+jVOw36/Tr73Gni
tfgM4heCyJleiaDLB8TE4KVNj0DJ4dy6r3qb3D2ppjYsJitfxO7DvA71pHsBIN8s
quFq0WDc+A747fBzbLpoMLbiA3yDUjaoCrfEzs831HuIHXVQaZunHz+R+Vkg6ZZg
rIs6cUbjW5z35pT2ZpoljLQZQwnTCWxTxo0fTMR30b0ms+mDk3FHBKT/9Yvnk//Z
Vgm3a+hqKAAlMXlE1dZjl5LH0wop8lKOUpQOeKwDCXMaMsmbZpC0C2UQ3n2eeE/R
/nqdrPl0/FGD7cJ7BlSaL3gsCoPfzLQ00XvUdvMsVQKBgQDNKuMxaeDQIg5v8h7+
/+2lElpRUdvrSrkz+5EArNYvwExeiIxDif6fF2EMHSYQYdKOvsQTYTgEcifCeBjv
CkkQuQ7gEGYsWEJdxbnEsMU56AXfV25Apyf9xisY5yuCA1BLxeKG0SKYL1xJGNmE
sVF9/6XDMZtF1W37S/15eQEC3wKBgQDJOb0NiDuBCsBT4AlaaJ3/uFqNqZU5Kl3m
/ewejVa3VfrfXvNYZsibXvEb/fpopY+ih/sle9hU+CzmoUV1MUz9Edb9rkPBTpDn
UUoC3qm8KQIi2PR2ffeP6fr8kxH2wbWB96JlCBrBqWCa9s2xZuxT8GrcnjVVM5Tt
oRa6yTCCYwKBgQCofWkZQodixiUvIBr+dbV3U+wiTmSaBcK1AwrhEA/SJU1ScTcn
nCMkCfIkHagN2hguLFIgTD3RwOIQHcr0PHEmr6OctTsDffP6yI+4DSfbV0XDVizw
IZaBHYZ1LBuZ6Ri/MaLH7uZHLtXOHf88rtZq8FD0TT/kCNQKhSyD3rDK5wKBgExZ
TfPudrVVgPfSD3pwK1K1fhY1+9p+yrY0LfzBn99cDh3mhupJxV++PDlkujguaTs/
4Pit7rz+lPrEwfffRtjWhf4muqqDxtMdsrk4BqrP3HGgY9D5po7CNmrS2oQHp3iy
nrk6w/wq6e6iKhVfede3ZrRiitXTBnTLJDam03MFAoGAX9xmxXJHXq6YlL9ezhxY
ze+f7z0MEDqNv71oS4248FBOIbvRjqc4LWN3v3+gdEOsX9KHler8kxs5JeOvr9t5
CJ5dfiT32CKl5MF62zXI3kIkEPTqaYOvZxPF8H9BHQ1nPhkLbaLReTfm4bDfHZyK
Mo23A3mFo9DdW+qQW+YNAQA=
-----END PRIVATE KEY-----`,

}
